import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import apiCall from '../../api';
import t from '../../translate';
import { nationalitieslist } from '../../utils';
import { setUiTranslation } from '../../../actions';
import logo from '../../../images/logo_moodlift.png';
import flag_en from '../../../images/language-switch-flag-en.png';
import flag_nl from '../../../images/language-switch-flag-nl.png';
import { getText } from '../panels/text/';
import eduTexts from './texts';
import EduLanding from './landing';
import './edu.css';

const EduRegistration = ({ coachToken, interventionSlug }) => {

  const dispatch = useDispatch();
  //Abonneer op uiTranslation zodat de component re-rendert wanneer de
  //translations geladen zijn — anders blijft t() de oude (NL) waardes geven.
  useSelector(state => state.uiTranslation);

  //Steps: 1=programma-keuze, 2=landingpagina, 3=registratieformulier, 4=bevestiging
  const [step, setStep] = useState(1)
  const [interventions, setInterventions] = useState([])
  const [registrationTexts, setRegistrationTexts] = useState(null)
  const [interventionTexts, setInterventionTexts] = useState(null)
  const [nationalities, setNationalities] = useState([])
  const [facultyOptions, setFacultyOptions] = useState([])

  //Universiteiten + faculteiten — overgenomen uit oude standaard step5.js.
  //Universiteit-keuze bepaalt de faculty-dropdown opties (cascade), met NL/EN varianten.
  const [faculteiten] = useState([
    {
      name_nl: 'Vrije Universiteit Amsterdam',
      name_eng: 'Vrije Universiteit Amsterdam',
      faculteiten_nl: ["Bètawetenschappen","Geesteswetenschappen","Gedrags- en Bewegingswetenschappen","Religie en Theologie","Rechtsgeleerdheid","Sociale Wetenschappen","Tandheelkunde - ACTA","Geneeskunde - VUmc School of Medical Sciences","School of Business and Economics"],
      faculteiten_eng: ["Science","Humanities","Behavioural and Movement Sciences","Religion and Theology","Law","Social Sciences","Dentistry","Medical Sciences","School of Business and Economics"]
    },
    {
      name_nl: 'Universiteit Utrecht',
      name_eng: 'Utrecht University',
      faculteiten_nl: ["Bètawetenschappen","Diergeneeskunde","Geesteswetenschappen","Geneeskunde","Geowetenschappen","Recht, Economie, Bestuur en Organisatie","Sociale Wetenschappen"],
      faculteiten_eng: ["Science","Veterinary Medicine","Humanities","Medicine","Geosciences","Law, Economics and Governance","Social and Behavioural Sciences"]
    },
    {
      name_nl: 'De Universiteit van Maastricht',
      name_eng: 'Maastricht University',
      faculteiten_nl: ["Cultuur- en Maatschappijwetenschappen","Health, Medicine and Life Sciences","Science and Engineering","Rechtsgeleerdheid","Psychology and Neuroscience","School of Business and Economics"],
      faculteiten_eng: ["Arts and Social Sciences","Health, Medicine and Life Sciences","Science and Engineering","Law","Psychology and Neuroscience","School of Business and Economics"]
    },
    {
      name_nl: 'Erasmus Universiteit Rotterdam',
      name_eng: 'Erasmus University Rotterdam',
      faculteiten_nl: ["Erasmus School of Economics","Erasmus School of Law","Erasmus School of History, Culture and Communication","Erasmus School of Social and Behavioural Sciences","Erasmus School of Philosophy","Erasmus Medical Centre","Rotterdam School of Management","International Institute of Social Studies","Erasmus School of Health Policy & Management","Erasmus University College","Institute for Housing and Urban Development Studies"],
      faculteiten_eng: ["Erasmus School of Economics","Erasmus School of Law","Erasmus School of History, Culture and Communication","Erasmus School of Social and Behavioural Sciences","Erasmus School of Philosophy","Erasmus Medical Centre","Rotterdam School of Management","International Institute of Social Studies","Erasmus School of Health Policy & Management","Erasmus University College","Institute for Housing and Urban Development Studies"]
    },
    {
      name_nl: 'Universiteit van Amsterdam',
      name_eng: 'University of Amsterdam',
      faculteiten_nl: ["Economie en Bedrijfskunde","Faculteit der Geesteswetenschappen","Faculteit der Geneeskunde","Faculteit der Maatschappij en Gedragswetenschappen","Faculteit der Natuurwetenschappen, Wiskunde en Informatica","Faculteit der Rechtsgeleerdheid","Faculteit der Tandheelkunde"],
      faculteiten_eng: ["Economics and Business","Faculty of Humanity","Faculty of Medicine","Faculty of Social and Behavioral Sciences","Faculty of Science","Amsterdam Law School","Faculty of Dentistry"]
    },
    {
      name_nl: 'Wageningen University & Research',
      name_eng: 'Wageningen University & Research',
      faculteiten_nl: ["Agrotechnologie & Voedingswetenschappen","Dierwetenschappen","Omgevingswetenschappen","Plantenwetenschappen","Maatschappijwetenschappen"],
      faculteiten_eng: ["Agrotechnology and Food Sciences","Animal Sciences","Environmental Sciences","Plant Sciences","Social Sciences"]
    }
  ])
  const [selectedIntervention, setSelectedIntervention] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [language_id, setLanguageId] = useState(1)
  const [submitting, setSubmitting] = useState(false)

  const [formData, setFormData] = useState({
    firstname: '',
    insertion: '',
    lastname: '',
    gender: '',
    email: '',
    age: '',
    nationality: '',
    university: '',
    faculty: '',
    password: '',
    password_check: '',
    intervention_id: 0
  })

  useEffect(() => {
    setNationalities(nationalitieslist[language_id])

    //Redux uiTranslation bijwerken zodat t() teruggrijpt op de juiste taal.
    //Voor NL leeg laten (t() retourneert dan de string ongewijzigd).
    if (parseInt(language_id) === 1) {
      dispatch(setUiTranslation(1, []))
    } else {
      apiCall({
        action: "get_ui_translation_strings_by_language",
        data: { language_id: language_id }
      }).then(resp => {
        if (resp && resp.translation) {
          dispatch(setUiTranslation(language_id, resp.translation))
        }
      })
    }
  }, [language_id])

  useEffect(() => {
    //Registratieteksten ophalen voor de landingpagina's per programma.
    apiCall({ action: "get_registration_texts", data: {} }).then(resp => {
      if (resp && resp.content) {
        setRegistrationTexts(resp.content)
      }
    })

    const tokenPromise = coachToken
      ? apiCall({ action: "validate_registration_link", data: { token: coachToken } })
      : Promise.resolve(null)

    Promise.all([
      apiCall({ action: "get_registrationable_interventions", data: {} }),
      tokenPromise
    ]).then(([interventionsResp, tokenResp]) => {
      if (interventionsResp && interventionsResp.interventions) {
        let availableInterventions = interventionsResp.interventions

        if (tokenResp && tokenResp.valid && tokenResp.intervention_id) {
          const tokenInterventionId = parseInt(tokenResp.intervention_id)
          const match = availableInterventions.find(i => parseInt(i.id) === tokenInterventionId)
          if (match) {
            setInterventions([match])
            setSelectedIntervention(match)
            setFormData(prev => ({...prev, intervention_id: match.id}))
            setStep(2) //naar landing
            return
          }
        }

        setInterventions(availableInterventions)

        if (interventionSlug) {
          const match = availableInterventions.find(i =>
            i.title.toLowerCase().replace(/[^a-z0-9]/g, '') === interventionSlug.toLowerCase().replace(/[^a-z0-9]/g, '')
          )
          if (match) {
            setSelectedIntervention(match)
            setFormData(prev => ({...prev, intervention_id: match.id}))
            setStep(2) //naar landing
          }
        }
      }
    })
  }, [])

  //interventionTexts updaten zodra registratieteksten geladen zijn óf de geselecteerde
  //interventie wijzigt — zo heeft de landingpagina altijd de juiste content.
  useEffect(() => {
    if (!registrationTexts || !selectedIntervention) {
      setInterventionTexts(null)
      return
    }
    const list = (registrationTexts.panel2 && registrationTexts.panel2.interventions) || []
    const match = list.find(i => parseInt(i.id) === parseInt(selectedIntervention.id))
    setInterventionTexts(match || null)
  }, [registrationTexts, selectedIntervention])

  function onChange(e) {
    setErrorMessage('')
    setFormData(prev => ({...prev, [e.target.name]: e.target.value}))
    //bij universiteit-wissel: faculteiten dropdown vullen op basis van keuze
    if (e.target.name === 'university') {
      fillFaculties(e.target.value)
      //ook reset faculty zodat oude keuze niet blijft staan
      setFormData(prev => ({...prev, university: e.target.value, faculty: ''}))
    }
  }

  function fillFaculties(university) {
    if (!university || university.length === 0) {
      setFacultyOptions([])
      return
    }
    let options = []
    faculteiten.forEach(f => {
      if (f.name_nl === university) {
        options = parseInt(language_id) === 1
          ? ["", ...f.faculteiten_nl]
          : ["", ...f.faculteiten_eng]
      }
    })
    setFacultyOptions(options)
  }

  //Faculteit-opties hertalen als de gebruiker midden in het formulier van taal wisselt
  useEffect(() => {
    if (formData.university) {
      fillFaculties(formData.university)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language_id])

  function selectIntervention(intervention) {
    setSelectedIntervention(intervention)
    setFormData(prev => ({...prev, intervention_id: intervention.id}))
    setStep(2) //naar landingpagina
  }

  function submitRegistration() {
    if (submitting) return
    setSubmitting(true)
    setErrorMessage('')
    setSuccessMessage('')

    apiCall({
      action: "edu_register",
      data: {
        ...formData,
        language_id: language_id,
        coach_token: coachToken || ''
      }
    }).then(resp => {
      setSubmitting(false)
      if (resp && resp.edu_register) {
        setSuccessMessage(resp.msg)
        setStep(4) //naar bevestiging
      } else if (resp && resp.msg) {
        setErrorMessage(resp.msg)
      }
    }).catch(() => setSubmitting(false))
  }

  //Stap 1: programma kiezen — vormgeving overgenomen van oude standaardflow step1
  if (step === 1) {
    return (
      <div className="registrationContainer">
        <header>
          <div className="brandLogo">
            <img className="logo" src={logo} alt="MoodLift" />
            <span className="brandLogo__tagline">Education</span>
          </div>
          <a className="btn login" href="/">{t("Log in")}</a>
          <div className="languageswitchheader" onClick={() => setLanguageId(language_id === 1 ? 2 : 1)}>
            <div className={language_id === 1 ? 'code active' : 'code pointer'}> NL <img src={flag_nl} style={{height: '20px'}} alt="NL" /> </div>
            <div className={language_id === 2 ? 'code active' : 'code pointer'}> EN <img src={flag_en} style={{height: '20px'}} alt="EN" /> </div>
          </div>
          <div className="container">
            <div className="intro">
              <h1>{eduTexts.step1.welcomeTitle[language_id === 1 ? 'nl' : 'en']}</h1>
              <p dangerouslySetInnerHTML={{__html: eduTexts.step1.welcomeIntro[language_id === 1 ? 'nl' : 'en']}}></p>
            </div>
          </div>
        </header>

        <div className="step1">
          <div className="container">
            <h2>{eduTexts.step1.programmesTitle[language_id === 1 ? 'nl' : 'en']}</h2>

            <div className="languageswitchheader" onClick={() => setLanguageId(language_id === 1 ? 2 : 1)}>
              <div className={language_id === 1 ? 'code active' : 'code pointer'}> NL <img src={flag_nl} style={{height: '20px'}} alt="NL" /> </div>
              <div className={language_id === 2 ? 'code active' : 'code pointer'}> EN <img src={flag_en} style={{height: '20px'}} alt="EN" /> </div>
            </div>

            <div className="intervention_holder">
              {interventions.map((intervention, index) => (
                <div className="intervention pointer" key={index} onClick={() => selectIntervention(intervention)}>
                  {intervention.image ?
                    <div className="image" style={{backgroundImage: "url('" + intervention.image + "')"}}></div>
                    : <></>
                  }
                  <h2 dangerouslySetInnerHTML={{__html: intervention.title}}></h2>
                  <div className="description">
                    {t(getText(intervention.id, "description_short"))}
                  </div>
                  <div className="btn_holder">
                    <span className="btn red">{t("Schrijf je in")}</span>
                  </div>
                </div>
              ))}

              {interventions.length > 0 && interventions.length % 3 ?
                <div className="intervention intervention_blank" style={{pointerEvents: "none"}}></div>
                : <></>
              }
            </div>

            {interventions.length === 0 ?
              <p className="text-center">{t("Programma's worden geladen...")}</p>
              : <></>
            }
          </div>
        </div>
      </div>
    )
  }

  //Stap 2: landingpagina van het gekozen programma
  if (step === 2 && selectedIntervention) {
    return (
      <EduLanding
        intervention={selectedIntervention}
        interventionTexts={interventionTexts}
        language_id={language_id}
        setLanguageId={setLanguageId}
        onContinue={() => setStep(3)}
        onBack={() => {
          setStep(1)
          setSelectedIntervention(null)
          setInterventionTexts(null)
          setFormData(prev => ({...prev, intervention_id: 0}))
        }}
      />
    )
  }

  //Stap 3: registratieformulier (look-and-feel van standaard step5)
  if (step === 3) {
    return (
      <div className="registrationContainer">
        <header>
          <div className="brandLogo">
            <img className="logo" src={logo} alt="MoodLift" />
            <span className="brandLogo__tagline">Education</span>
          </div>
          <a className="btn login" href="/">{t("Log in")}</a>
          <div className="languageswitchheader" onClick={() => setLanguageId(language_id === 1 ? 2 : 1)}>
            <div className={language_id === 1 ? 'code active' : 'code pointer'}> NL <img src={flag_nl} style={{height: '20px'}} alt="NL" /> </div>
            <div className={language_id === 2 ? 'code active' : 'code pointer'}> EN <img src={flag_en} style={{height: '20px'}} alt="EN" /> </div>
          </div>
        </header>

        <div className="step6">
          <button type="button" className="btn prev" onClick={() => setStep(2)}>{t("Terug")}</button>

          <div className="container">

            <div className="content">
              <div className="intro">
                <h1>{t("Aanmelden voor")} {selectedIntervention ? selectedIntervention.title : ''}</h1>
                <p><span dangerouslySetInnerHTML={{__html : t('Hiermee krijg je een account op het educatieplatform van MoodLift. Wil je een account om echt aan je welzijn te werken? Schrijf je dan in via ons gewone platform')}} />: <a href="https://moodlift.nl">moodlift.nl</a></p>
              </div>

              {errorMessage.length > 0 ?
                <div className="alert alert-danger">
                  <i className="fas fa-exclamation-circle"></i> &nbsp;
                  <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
                </div>
                : <></>
              }

              <form>
                <div className="form-row align-items-center">
                  <div className="col-auto col-40 form-label-group">
                    <input
                      type="text"
                      className="form-control"
                      id="firstname"
                      name="firstname"
                      aria-describedby="firstname"
                      placeholder=" "
                      value={formData.firstname}
                      onChange={onChange}
                    />
                    <label htmlFor="firstname">{t("Voornaam")}</label>
                  </div>
                  <div className="col-auto col-20 form-label-group">
                    <input
                      type="text"
                      className="form-control"
                      id="insertion"
                      name="insertion"
                      aria-describedby="insertion"
                      placeholder=" "
                      value={formData.insertion}
                      onChange={onChange}
                    />
                    <label htmlFor="insertion">{t("Tussenvoegsel")}</label>
                  </div>
                  <div className="col-auto col-40 form-label-group">
                    <input
                      type="text"
                      className="form-control"
                      id="lastname"
                      name="lastname"
                      aria-describedby="lastname"
                      placeholder=" "
                      value={formData.lastname}
                      onChange={onChange}
                    />
                    <label htmlFor="lastname">{t("Achternaam")}</label>
                  </div>
                </div>

                <div className="form-row align-items-center bigLabel">
                  <div className="col">
                    <input
                      type="radio"
                      className="form-control"
                      id="gender_f"
                      name="gender"
                      aria-describedby="gender"
                      value="F"
                      onChange={onChange}
                      checked={formData.gender === 'F'}
                    /> <label htmlFor="gender_f">{t("Vrouw")}</label>
                    <input
                      type="radio"
                      className="form-control"
                      id="gender_m"
                      name="gender"
                      aria-describedby="gender"
                      value="M"
                      onChange={onChange}
                      checked={formData.gender === 'M'}
                    /> <label htmlFor="gender_m">{t("Man")}</label>
                    <input
                      type="radio"
                      className="form-control"
                      id="gender_x"
                      name="gender"
                      aria-describedby="gender"
                      value="X"
                      onChange={onChange}
                      checked={formData.gender === 'X'}
                    /> <label htmlFor="gender_x">{t("Anders")}</label>
                  </div>
                </div>

                <div className="form-row align-items-center">
                  <div className="col form-label-group">
                    <input
                      type="text"
                      className="form-control"
                      id="email"
                      name="email"
                      aria-describedby="email"
                      placeholder=" "
                      value={formData.email}
                      onChange={onChange}
                      autoCorrect="off"
                      autoCapitalize="none"
                    />
                    <label htmlFor="email">{t("Studenten-e-mailadres")}</label>
                  </div>
                </div>

                <div className="form-row align-items-center" style={{marginTop: '-20px'}}>
                  <div className="col-auto col-50 form-group form-label-group">
                    <input
                      type="number"
                      className="form-control"
                      id="age"
                      name="age"
                      aria-describedby="age"
                      value={formData.age}
                      onChange={onChange}
                      min="16"
                      max="99"
                      step="1"
                      maxLength="2"
                      style={{marginTop: '24px'}}
                    />
                    <label htmlFor="age" style={{marginTop: '-12px'}}>{t("Leeftijd")}</label>
                  </div>
                  <div className="col-50 form-group">
                    <label htmlFor="nationality" style={{marginBottom: '-2px', marginLeft: '11px'}}>{t("Nationaliteit")}</label>
                    <select
                      id="nationality"
                      name="nationality"
                      value={formData.nationality}
                      onChange={onChange}
                      className="form-control"
                      style={{paddingLeft: '5px'}}
                    >
                      <option value=""></option>
                      {nationalities.map((n, index) => (
                        <option key={index} value={index}>{n}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row align-items-center" style={{marginTop: '-20px'}}>
                  <div className="col-50 form-group">
                    <label htmlFor="university" style={{marginBottom: '-2px', marginLeft: '11px'}}>{t("Universiteit/Hogeschool")}</label>
                    <select
                      id="university"
                      name="university"
                      value={formData.university}
                      onChange={onChange}
                      className="form-control"
                      style={{paddingLeft: '5px'}}
                    >
                      <option value=""></option>
                      {faculteiten.map((f, index) => (
                        <option key={index} value={f.name_nl}>
                          {parseInt(language_id) === 1 ? f.name_nl : f.name_eng}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-50 form-group">
                    <label htmlFor="faculty" style={{marginBottom: '-2px', marginLeft: '11px'}}>{t("Faculteit")}</label>
                    <select
                      id="faculty"
                      name="faculty"
                      value={formData.faculty}
                      onChange={onChange}
                      className="form-control"
                      style={{paddingLeft: '5px'}}
                    >
                      {facultyOptions.length === 0 ?
                        <option value="">{t("Selecteer eerst een universiteit/hogeschool")}</option>
                        : ''}
                      {facultyOptions.map((f, index) => (
                        <option key={index} value={f}>{f}</option>
                      ))}
                      {facultyOptions.length !== 0 ?
                        <option value="Ik weet het niet">{t("Ik weet het niet")}</option>
                        : ''}
                    </select>
                  </div>
                </div>

                <div className="form-row align-items-center">
                  <div className="col-50 form-label-group">
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      name="password"
                      aria-describedby="password"
                      placeholder=" "
                      value={formData.password}
                      onChange={onChange}
                      autoCorrect="off"
                      autoCapitalize="none"
                    />
                    <label htmlFor="password">{t("Wachtwoord")}</label>
                  </div>
                  <div className="col-50 form-label-group">
                    <input
                      type="password"
                      className="form-control"
                      id="password_check"
                      name="password_check"
                      aria-describedby="password_check"
                      placeholder=" "
                      value={formData.password_check}
                      onChange={onChange}
                      autoCorrect="off"
                      autoCapitalize="none"
                    />
                    <label htmlFor="password_check">{t("Wachtwoord ter controle")}</label>
                  </div>
                </div>

                <div className="button_holder">
                  <button type="button" className="btn btn-primary" onClick={submitRegistration} disabled={submitting}>
                    {submitting ? t("Bezig...") : t("Helemaal klaar!")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }

  //Stap 4: bevestiging (default render — fallback wanneer step === 4 of een onverwachte waarde)
  return (
    <div className="registrationContainer">
      <div className="step6">
        <div className="container">
          <div className="content">
            <div style={{textAlign: 'center'}}>
              <h1>{t("Gelukt! Je account is aangemaakt, je moet deze alleen nog activeren.")}</h1>
              <p dangerouslySetInnerHTML={{ __html: successMessage }} />
              <br />
              <a href="/" className="btn btn-primary">{t("Ga naar inloggen")}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EduRegistration;
